import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../../shared/shared.module';
import { ModalsModule } from '../../modals/modals.module';
import { AccountFunnelsRouting } from './account-funnels.routing';
import { AccountFunnelsLayoutComponent } from './layout/account-funnels-layout.component';
import { AccountFunnelsListComponent } from './list/account-funnels-list.component';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { AccountFunnelsSideMenuComponent } from './side-menu/account-funnels-side-menu.component';
import { AccountGroupsComponent } from './groups/account-groups.component';
import { AccountTimeTablesComponent } from './timetables/account-timetables.component';

@NgModule({
  declarations: [
    AccountFunnelsLayoutComponent,
    AccountFunnelsSideMenuComponent,
    AccountFunnelsListComponent,
    AccountGroupsComponent,
    AccountTimeTablesComponent,
  ],
  exports: [
    AccountFunnelsLayoutComponent,
    AccountFunnelsSideMenuComponent,
    AccountFunnelsListComponent,
    AccountGroupsComponent,
    AccountTimeTablesComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ModalsModule,
    SharedModule,
    ReactiveFormsModule,
    AccountFunnelsRouting,
    PaginationModule.forRoot(),
    TooltipModule.forRoot(),
  ],
})
export class AccountFunnelsModule {
  constructor() {
    console.log('>>> Bootstrap AccountFunnelsModule');
  }
}
